export const LOCATIONS = {
  mandsaur: {
    id: "mandsaur",
    name: "Mandsaur",
    address:
      "Behind Girls College, near Teliya Talab, Bhatrewas, Mandsaur, Madhya Pradesh 458001",
    hours: ["11:00 AM - 3:00 PM", "06:00 PM - 11:00 PM"],
    phoneDisplay: "095757 98248",
    phoneHref: "tel:+919575798248",
    whatsapp: "919575798248",
    email: "secondhomemds@gmail.com",
    mapEmbedSrc:
      "https://maps.google.com/maps?q=Second+Home+Kitchen+Restaurant+Teliya+Talab+Bhatrewas+Mandsaur&t=m&z=15&output=embed",
    directionsUrl: "https://maps.app.goo.gl/2WY17kBFmxUiQfLn9",
  },
  neemuch: {
    id: "neemuch",
    name: "Neemuch",
    address:
      "Neemuch City Rd, near Sundram Cinema, near Sanwaliya Seth Ji Temple, Neemuch, Madhya Pradesh 458441",
    hours: ["11:00 AM - 3:00 PM", "06:00 PM - 11:00 PM"],
    phoneDisplay: "072258 98248",
    phoneHref: "tel:+917225898248",
    whatsapp: "917225898248",
    email: "Secondhomeneemuch@gmail.com",
    mapEmbedSrc:
      "https://maps.google.com/maps?q=Second+Home+Kitchen+Restaurant+Neemuch+City+Road+Sundram+Cinema&t=m&z=15&output=embed",
    directionsUrl: "https://maps.app.goo.gl/TdwGLSyWT5LKCP9Z6",
  },
};

export const LOCATION_LIST = Object.values(LOCATIONS);

export const DEFAULT_LOCATION_ID = "mandsaur";
